import App from 'app/app.js';

//** localization
import 'app/i18n/localeENUS.js';
import 'app/i18n/localeESUS.js';
import 'app/i18n/localeFRCA.js';
import 'app/service/StorageService.js';
import 'app/action/DeserializeAction.js';

var locale = {
    ENGLISH: 'en-us',
    SPANISH: 'es-us',
    FRENCH: 'fr-ca'
  },
  activeLocale = locale.ENGLISH,
  overrideValues = function (oldObject, newObject) {
    angular.forEach(oldObject, function (value, key) {
      if (!newObject[key]) {
        delete oldObject[key];
      } else if (angular.isArray(newObject[key])) {
        oldObject[key].length = newObject[key].length;
      }
    });
    angular.forEach(newObject, function (value, key) {
      if (angular.isArray(newObject[key]) || angular.isObject(newObject[key])) {
        if (!oldObject[key]) {
          oldObject[key] = angular.isArray(newObject[key]) ? [] : {};
        }
        overrideValues(oldObject[key], newObject[key]);
      } else {
        oldObject[key] = newObject[key];
      }
    });
  },
  TranslateProviderService = function (
    $locale,
    $localeENUS,
    $localeESUS,
    $localeFRCA,
    $location,
    eventService,
    StorageService,
    DeserializeAction,
    $injector
  ) {
    var updateLocale = function (newLocale) {
      if (activeLocale !== newLocale) {
        activeLocale = newLocale;

        switch (newLocale) {
          case locale.SPANISH:
            overrideValues($locale, $localeESUS);
            break;
          case locale.FRENCH:
            overrideValues($locale, $localeFRCA);
            break;
          default:
            overrideValues($locale, $localeENUS);
        }
      }
      eventService.dispatch('localeChange', newLocale);
    };

    this.onDeserialize = function (type, data) {
      if (!!data && !!data.locale) {
        updateLocale(data.locale.locale);
      }
    };

    DeserializeAction.register(this.onDeserialize.bind(this));

    return {
      locale: locale,
      setLocale: function (newLocale) {
        var AnalyticsService = $injector.get('AnalyticsService');
        AnalyticsService.recordEvent(AnalyticsService.events.LANG_CHANGE);

        updateLocale(newLocale);
        StorageService.setData('locale', {
          locale: activeLocale
        });
      },
      getLocale: function () {
        return activeLocale;
      },
      domain: function () {
        return /(my-ca\S+)|(\.ca$)/i.test($location.host()) ? 'Canada' : 'US';
      },
      getShortMonths: function () {
        return $locale.DATETIME_FORMATS.SHORTMONTH;
      },
      isCanadianDomain: function () {
        return this.domain() === 'Canada';
      },
      getDecimalSeperator: function () {
        return $locale.NUMBER_FORMATS.DECIMAL_SEP || '.';
      }
    };
  };

App.factory('TranslateProviderService', [
  '$locale',
  '$localeENUS',
  '$localeESUS',
  '$localeFRCA',
  '$location',
  'EventService',
  'StorageService',
  'DeserializeAction',
  '$injector',
  TranslateProviderService
]);
